import * as React from "react"
import { List } from "semantic-ui-react"
import { ITranslations } from "../../../models"
import { Multilang } from "../../../models/product/multilang-string"
import {
  IRawSupplierDeclinedReference,
  IRawSupplierReference,
  completeRawDeclined,
} from "../../../models/product/product"
import { Languages } from "../../../utils"
import ButtonLink from "../buttons/com_button-link"

interface IMiniListProps {
  productTree: IRawSupplierReference
  activeLang: Languages
  translations: ITranslations["sideBar"]
  onClick: () => void
}

const MiniList = (props: IMiniListProps) => {
  const { productTree, activeLang, translations, onClick } = props

  let declined = productTree.declined

  return (
    <List.Item>
      <List.Icon
        name={declined ? "folder open" : "file"}
        className={getColorClassName(productTree)}
      />
      <List.Content>
        <List.Header>
          {productTree ? (
            <ButtonLink
              key={productTree.droopyId}
              to={`${productTree.droopyId}`}
              className={getColorClassName(productTree)}
              onClick={onClick}
            >
              {Multilang.String.GetValue(productTree.label, activeLang)}
            </ButtonLink>
          ) : null}
        </List.Header>
        <List.Description>
          {!productTree.isTopRef
            ? translations.description + productTree.supplierRef
            : ""}
        </List.Description>
        {declined && getDeclinedElement(productTree, declined, props)}
      </List.Content>
    </List.Item>
  )
}

const getColorClassName = (product: IRawSupplierReference) => {
  return !product.isValid
    ? "invalid"
    : !product.activated
    ? "inactive"
    : getValidatedClassName[product.validated ? "True" : "False"]
}

const getValidatedClassName = {
  ["True"]: "validated",
  ["False"]: "notValidated",
  ["Head"]: "normal",
}

const getDeclinedElement = (
  topRef: IRawSupplierReference,
  declined: IRawSupplierDeclinedReference[],
  props: IMiniListProps
) => {
  const { activeLang, translations, onClick } = props
  return (
    <List.List>
      {declined.map((c: IRawSupplierDeclinedReference, index: number) => {
        const child = completeRawDeclined(topRef, c)
        return (
          <List.Item key={index}>
            <List.Icon name="file" className={getColorClassName(child)} />
            <List.Content>
              <List.Header>
                <ButtonLink
                  key={child.droopyId}
                  to={`${topRef.droopyId}/${child.droopyId}`}
                  className={getColorClassName(child)}
                  onClick={onClick}
                >
                  {Multilang.String.GetValue(child.label, activeLang)}
                </ButtonLink>
              </List.Header>
              <List.Description>
                {child.supplierRef
                  ? translations.description + child.supplierRef
                  : translations.missingInfos}
              </List.Description>
            </List.Content>
          </List.Item>
        )
      })}
    </List.List>
  )
}

export default MiniList
